<template>
  <div
    class="my-5 border-b border-gray-200 text-center font-medium text-gray-500 dark:border-gray-700 dark:text-gray-400 not-prose"
  >
    <ul class="m-0 flex list-none flex-wrap p-0">
      <li v-for="tab in optionsList" :key="tab" class="m-0 flex-1 p-0">
        <div
          class="rounded-t-lg p-4"
          :class="{
            'border-b-2 border-blue-600 text-blue-600 dark:border-blue-500 dark:text-blue-500 ':
              selectedTab === tab,
            'border-b-2 border-transparent hover:border-gray-300 hover:text-gray-600 dark:hover:border-dark-3 dark:hover:text-gray-300':
              selectedTab !== tab,
          }"
          :data-testId="`${tab}_tab`"
          @click="selectTab(tab)"
        >
          {{ tab }}
        </div>
      </li>
    </ul>
  </div>
</template>
<script setup lang="ts">
const props = defineProps<{
  selectedTab: string;
  selectTab: (tab: string) => void;
  optionsList: string[];
}>();
</script>
